import { http } from '../http'
import { URL } from './_constant'

/**
 * 小区管理-列表
 */
export function API_COMMUNITY_LIST(data?: BasicPageReq) {
  return http.post<ApiCommunity.ListRes>(URL.LIST, data)
}

/**
 * 小区管理-全部
 */
export function API_COMMUNITY_ALL(data?: BasicPageReq) {
  return http.post<ApiCommunity.Item[]>(URL.LIST, data)
}

/**
 * 小区管理-详情
 */
export function API_COMMUNITY_DETAIL(id: string) {
  return http.post<ApiCommunity.Item>(URL.DETAIL, { id })
}

/**
 * 小区管理-新增
 */
export function API_COMMUNITY_ADD(data: ApiCommunity.Item) {
  return http.post(URL.ADD, data)
}

/**
 * 小区管理-删除
 */
export function API_COMMUNITY_DEL(data: IdsPayload) {
  return http.post(URL.DEL, data)
}

/**
 *  小区管理-编辑
 */
export function API_COMMUNITY_EDIT(data: BasicUpdateOneReq<ApiCommunity.Item>) {
  return http.post(URL.EDIT, data)
}

/**
 *  小区管理-禁用
 */
export function API_COMMUNITY_DISABLE(data: IdsPayload) {
  return http.post(URL.DISABLE, data)
}

/**
 * 小区管理-启用
 */
export function API_COMMUNITY_ENABLE(data: IdsPayload) {
  return http.post(URL.ENABLE, data)
}

/**
 * 小区管理-排序
 */
export function API_COMMUNITY_ORDER(data: BasicOrderData) {
  return http.post(URL.ORDER, data)
}

/**
 * 小区管理-获取已安置信息
 */
export function API_COMMUNITY_SETTLE_LIST(id: string) {
  return http.post(URL.SETTLE_LIST, { id })
}

/**
 * 小区管理-统计分析1
 */
export function API_COMMUNITY_ANA1(data: ApiCommunity.AnaReq) {
  return http.post<ApiCommunity.AnaRes>(URL.ANA1, data)
}

/**
 * 小区管理-统计分析2
 */
export function API_COMMUNITY_ANA2(data: ApiCommunity.AnaReq) {
  return http.post<ApiCommunity.AnaRes>(URL.ANA2, data)
}
